export default class TransactionTypes {
  static DEPOSIT = "deposit";

  static WITHDRAW = "withdraw";
}
